//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AccountForm from "../components/AccountForm.vue";
import NavBar from "../components/NavBar.vue";
import store from "./../store";
import { Toast } from "./../utils/helpers";
import usersAPI from "./../apis/users.js";
import CreateTweets from "../components/CreateTweet.vue";

export default {
  name: "Setting",
  components: { AccountForm, NavBar, CreateTweets },
  data() {
    return {
      currentUser: {
        id: "",
        account: "",
        name: "",
        email: "",
      },
    };
  },
  mounted() {
    this.fetchUserInfo();
  },
  methods: {
    fetchUserInfo() {
      const { account, name, email, id } = store.state.currentUser;
      this.currentUser = { account, name, email, id };
    },
    async handleSubmit(formData) {
      try {
        const { name, account, email, password, checkPassword, id } = formData;

        const response = await usersAPI.settingUserAccount(id, {
          name: name,
          account: account,
          email: email,
          password: password,
          checkPassword: checkPassword,
        });

        const { data } = response;
        if (data.status !== "success") {
          throw new Error(data.message);
        }

        Toast.fire({
          icon: "success",
          title: data.message,
        });

        this.$store.dispatch("fetchCurrentUser");
        this.$router.push("/main");
      } catch (error) {
        Toast.fire({
          icon: "warning",
          title: error.message,
        });
      }
    },
  },
};
